import { render, staticRenderFns } from "./memberbalance-transfer-balance.vue?vue&type=template&id=7a48c924&"
import script from "./memberbalance-transfer-balance.vue?vue&type=script&lang=js&"
export * from "./memberbalance-transfer-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports